import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConciliarContaListarRoutingModule } from './conciliar-conta-listar-routing.module';
import { ConciliarContaListarComponent } from './conciliar-conta-listar.component';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessagesModule } from 'primeng/messages';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';


@NgModule({
  declarations: [
    ConciliarContaListarComponent
  ],
  imports: [
    CommonModule,
    ConciliarContaListarRoutingModule,
    FormsModule,
    TableModule,
    DropdownModule,
    DividerModule,
    ProgressSpinnerModule,
    MessagesModule,
    InputTextModule,
    InputNumberModule,
    ButtonModule,
    DialogModule,
    TooltipModule,
    CalendarModule
    
  ]
})
export class ConciliarContaListarModule { }
